// JavaScript Document


function ParallaxBgImg() {

    gsap.utils.toArray(".paralax-bg .bg-img").forEach((section, i) => { 
        const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
        function setParallaxEffect() {
             gsap.fromTo(section,{ 
                y: -heightDiff,

                  // rotationZ: 6,
                  //  scale:1.1,
              }, {
                scrollTrigger: {
                     start: "top bottom",
                  trigger: section,
                  scrub: true,

                },
                y: 0,
                // scale:1,
                  // rotationZ: 0,
                ease: "none"
              });

        }

         setParallaxEffect();

    });



}
